<script>
export default {
  name: "CustoConsulta",
  props: {
    custo:  {
      type: Object,
      required: true
    },
    tipo: {
      type: String,
      default: 'consulta'
    }
  }
}
</script>

<template>
<div>
  <div class="custo-consulta w-[310px]">
    <p class="text-sm font-medium text-gray-600">Custo da {{ tipo }}</p>
    <div>
      <span class="font-semibold">{{ custo['valor'] }}</span>
      <span class="text-xs font-normal text-gray-500" v-if="custo['faixa']">
          até {{ custo['faixa'] }} {{ custo['faixa_tipo'] }}
        </span>
      <div class="font-medium text-xs text-gray-600 mt-1" v-if="custo['faixa']">
        + {{ custo['valor_desconto'] }} a cada {{ custo['faixa'] }} adicionais.
      </div>
    </div>
  </div>

</div>
</template>

<style scoped lang="stylus">
.custo-consulta
  background-color #F0F0F0
  padding 18px
  width 100%
  border-radius 10px
  margin 1rem 0
  display flex
  gap 1.5rem

.custo-consulta p
  white-space nowrap
  margin-bottom 0
</style>
